import { lazy, Suspense } from 'react';
import { useResponsiveComponent } from '@/hooks/useResponsiveComponent';

// Lazy load mobile and desktop components
const ServiceInfoPage = lazy(() => import('./buyer/ServiceInfoPage').then(module => ({ default: module.ServiceInfoPage })));
const DesktopServiceInfoPage = lazy(() => import('./desktop/DesktopServiceInfoPage').then(module => ({ default: module.DesktopServiceInfoPage })));

// Loading component for suspense fallback
function ServiceInfoPageLoader() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="w-8 h-8 border-4 border-gray-200 border-t-[#86DB89] rounded-full animate-spin"></div>
        <p className="text-[#666666] text-base">서비스 정보 페이지를 불러오는 중...</p>
      </div>
    </div>
  );
}

/**
 * Responsive wrapper that automatically switches between mobile and desktop
 * versions of the Service Info page based on screen size (1024px breakpoint)
 */
export function ResponsiveServiceInfoPage() {
  const isDesktop = useResponsiveComponent(1024);

  return (
    <Suspense fallback={<ServiceInfoPageLoader />}>
      {isDesktop ? <DesktopServiceInfoPage /> : <ServiceInfoPage />}
    </Suspense>
  );
}